module.exports = __webpack_public_path__ + "img/belgium-transport-accidents-female.0729a815.png";